import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
var _templateObject, _templateObject2, _templateObject3, _templateObject4;
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { withVDSManager } from '@vds-core/utilities';
import { ratios } from '../util/ratios';
import { breakpoints } from '../util/breakpoints';
import urlParser from '../util/urlParser';
import setQltParam from '../util/urlParamsHelpers';
var propTypes = {
  /**
   * URL for the image. Will fallback to this if no sources or none allowed in browser.
   */
  url: PropTypes.string,
  /**
   * Specifies aspect ratio of the Image.
   */
  ratio: PropTypes.oneOf(['16:9', '9:4', '9:2', '8:3', '5:7', '5:6', '5:4', '4:3', '4:1', '3:1', '3:2', '2:1', '2:3', '9:16', '4:7', '4:9', '1:2', '1:1']),
  /**
   * Alternative text for the image.
   */
  alt: PropTypes.string,
  /**
   * ARIA role of the Image.
   */
  role: PropTypes.string,
  /**
   * ARIA label of the Image Wrapper - To be used in the case of an onClick() to inidicate the action.
   */
  ariaLabel: PropTypes.string,
  /**
   * onClick event listener of the Image.
   */
  onClick: PropTypes.func,
  /**
   * An array of image data.
   */
  // sources: PropTypes.arrayOf(PropTypes.object({
  //   srcset: PropTypes.string,
  //   type: PropTypes.string, // MIME type for image
  //   maxViewport: PropTypes.oneOf(['mobile', 'tablet', 'desktop'])
  // })),
  source: PropTypes.array,
  /**
   * Horizontal focus of the image.
   */
  focusX: PropTypes.oneOf(['center', 'left', 'right']),
  /**
   * Vertical focus of the image.
   */
  focusY: PropTypes.oneOf(['center', 'top', 'bottom']),
  /**
   * Horizontal position of the image when not using aspect ratios.
   */
  positionX: PropTypes.oneOf(['center', 'left', 'right']),
  /**
   * Vertical position of the image when not using aspect ratios.
   */
  positionY: PropTypes.oneOf(['center', 'top', 'bottom']),
  /**
   * Set the image dimensions relative to the width.
   */
  constrainToWidth: PropTypes.bool,
  /**
   * Set the image dimensions relative to the height.
   */
  constrainToHeight: PropTypes.bool,
  /**
   * Use a preset aspect ratio specified in VDS themes.
   */
  hasAspectRatio: PropTypes.bool,
  /**
   * Percentage height the image should be in its container when not using aspect ratios.
   */
  size: PropTypes.string,
  /**
   * Enable Lazy Loading.
   */
  lazy: PropTypes.bool
};
var defaultProps = {
  ratio: '16:9',
  role: 'img',
  focusX: 'center',
  focusY: 'center',
  size: '100%',
  positionY: 'center',
  positionX: 'center',
  lazy: false
};
function _getImageRatio(ratio) {
  return ratios[ratio];
}
var ImageWrapper = /*#__PURE__*/styled.div.withConfig({
  displayName: "ImageWrapper",
  componentId: "VDS__sc-1bbiz5z-0"
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  position: relative;\n  height: auto;\n  overflow: hidden;\n  padding-top: ", "%;\n  width: 100%;\n  text-align: center;\n"])), function (_ref) {
  var ratio = _ref.ratio;
  return ratio;
});

//When there's no aspect ratio
var ImageElement = /*#__PURE__*/styled.img.withConfig({
  displayName: "ImageElement",
  componentId: "VDS__sc-1bbiz5z-1"
})(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  display: flex;\n  max-width: 100%;\n  margin-top: ", ";\n  margin-bottom: ", ";\n  margin-left: ", ";\n  margin-right: ", ";\n  height: ", ";\n  ", "\n"])), function (_ref2) {
  var positionY = _ref2.positionY;
  return ('bottom' === positionY || 'center' === positionY) && 'auto';
}, function (_ref3) {
  var positionY = _ref3.positionY;
  return ('top' === positionY || 'center' === positionY) && 'auto';
}, function (_ref4) {
  var hasAspectRatio = _ref4.hasAspectRatio,
    positionX = _ref4.positionX;
  return !hasAspectRatio && ('right' === positionX || 'center' === positionX) && 'auto';
}, function (_ref5) {
  var hasAspectRatio = _ref5.hasAspectRatio,
    positionX = _ref5.positionX;
  return !hasAspectRatio && ('left' === positionX || 'center' === positionX) && 'auto';
}, function (_ref6) {
  var size = _ref6.size;
  return size;
}, function (_ref7) {
  var onClick = _ref7.onClick;
  return onClick && "\n    &:hover {\n      cursor: pointer;\n    }\n  ";
});

//When theres sources
var Picture = /*#__PURE__*/styled.picture.withConfig({
  displayName: "Picture",
  componentId: "VDS__sc-1bbiz5z-2"
})(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  display: ", ";\n  width: ", ";\n  margin-left: ", ";\n  margin-right: ", ";\n"])), function (_ref8) {
  var hasAspectRatio = _ref8.hasAspectRatio;
  return !hasAspectRatio && 'flex';
}, function (_ref9) {
  var hasAspectRatio = _ref9.hasAspectRatio;
  return !hasAspectRatio && '100%';
}, function (_ref10) {
  var hasAspectRatio = _ref10.hasAspectRatio,
    positionX = _ref10.positionX;
  return !hasAspectRatio && ('right' === positionX || 'center' === positionX) && 'auto';
}, function (_ref11) {
  var hasAspectRatio = _ref11.hasAspectRatio,
    positionX = _ref11.positionX;
  return !hasAspectRatio && ('left' === positionX || 'center' === positionX) && 'auto';
});

//When there IS an aspect ratio
var BackgroundImage = /*#__PURE__*/styled.img.withConfig({
  displayName: "BackgroundImage",
  componentId: "VDS__sc-1bbiz5z-3"
})(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  position: absolute;\n  background-position: center center;\n  object-fit: cover;\n  background-size: cover;\n  ", "\n\n  ", "\n"])), function (_ref12) {
  var onClick = _ref12.onClick;
  return onClick && "\n    &:hover {\n      cursor: pointer;\n    }\n  ";
}, function (_ref13) {
  var focusX = _ref13.focusX,
    focusY = _ref13.focusY,
    constrainToWidth = _ref13.constrainToWidth,
    constrainToHeight = _ref13.constrainToHeight;
  if (constrainToWidth) {
    return "\n        width:100%;\n        left: 0;\n        right: 0;\n        top: 0;\n        ".concat(getVerticalTransform(focusY));
  } else if (constrainToHeight) {
    return "height:100%;\n              top:0;\n              bottom:0;\n              ".concat(getHorizontalTransform(focusX));
  } else {
    return "height: 100%;\n              width: 100%;\n              top: 0;\n              left: 0;";
  }
});
var getHorizontalTransform = function getHorizontalTransform(focusX) {
  switch (focusX) {
    case 'left':
      return "left:0;transform: translateX(0)";
    case 'right':
      return "right:0;transform:translateX(0)";
    case 'center':
    default:
      return "left:50%;transform:translateX(-50%);";
  }
};
var getVerticalTransform = function getVerticalTransform(focusY) {
  switch (focusY) {
    case 'top':
      return "top:0;transform: translateY(0)";
    case 'bottom':
      return "bottom:0;transform:translateY(0)";
    case 'center':
    default:
      return "top:50%;transform:translateY(-50%);";
  }
};

// ImageElement.defaultProps = {
//   role: "img"
// };

var renderSourceElement = function renderSourceElement(_ref14, index) {
  var srcset = _ref14.srcset,
    type = _ref14.type,
    maxViewport = _ref14.maxViewport;
  if (!srcset) return '';
  var media = undefined;
  if (maxViewport && breakpoints[maxViewport]) {
    if (maxViewport === 'desktop') {
      media = "(min-width: ".concat(breakpoints[maxViewport], "px)");
    } else {
      media = "(max-width: ".concat(breakpoints[maxViewport], "px)");
    }
  }
  return /*#__PURE__*/React.createElement("source", {
    key: "imgSrc-".concat(index),
    srcSet: srcset,
    type: type,
    media: media
  });
};
var Image = /*#__PURE__*/function (_React$Component) {
  _inherits(Image, _React$Component);
  var _super = _createSuper(Image);
  function Image(props) {
    var _this;
    _classCallCheck(this, Image);
    _this = _super.call(this, props);
    _this.state = {
      constrainToHeight: undefined,
      constrainToWidth: undefined
    };
    _this.onImgLoad = _this.onImgLoad.bind(_assertThisInitialized(_this));
    return _this;
  }
  _createClass(Image, [{
    key: "onImgLoad",
    value: function onImgLoad(_ref15) {
      var img = _ref15.target;
      var autosize = this.props.autosize;
      // If it's not ie, don't do anything, our CSS will take care of things
      if (!this.state.isIe && !autosize) return;
      if (img.naturalWidth >= img.naturalHeight) {
        this.setState({
          constrainToHeight: true,
          constrainToWidth: undefined
        });
      } else {
        this.setState({
          constrainToHeight: undefined,
          constrainToWidth: true
        });
      }
    }
  }, {
    key: "_addQTLqueryToURL",
    value: function _addQTLqueryToURL(url) {
      var qlt = this.props.qlt;
      var _qlt = qlt && "".concat(qlt, ",0");
      var _url = urlParser(url);
      return setQltParam(_url, _qlt);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
        url = _this$props.url,
        size = _this$props.size,
        positionY = _this$props.positionY,
        positionX = _this$props.positionX,
        ratio = _this$props.ratio,
        alt = _this$props.alt,
        ariaLabel = _this$props.ariaLabel,
        onClick = _this$props.onClick,
        sources = _this$props.sources,
        focusX = _this$props.focusX,
        focusY = _this$props.focusY,
        lazy = _this$props.lazy,
        constrainToWidth = _this$props.constrainToWidth,
        constrainToHeight = _this$props.constrainToHeight,
        hasAspectRatio = _this$props.hasAspectRatio,
        ariaHidden = _this$props.ariaHidden;
      var imageRatio = _getImageRatio(ratio);
      var ImageType = hasAspectRatio ? BackgroundImage : ImageElement;
      var _url = this._addQTLqueryToURL(url);
      var ImageComponent = /*#__PURE__*/React.createElement(ImageType, {
        hasAspectRatio: hasAspectRatio,
        size: size,
        positionY: positionY,
        positionX: positionX,
        ratio: imageRatio,
        src: _url,
        alt: alt,
        loading: lazy ? 'lazy' : 'auto' //https://web.dev/native-lazy-loading/
        ,
        focusX: focusX,
        focusY: focusY,
        constrainToWidth: this.state.constrainToWidth || constrainToWidth,
        constrainToHeight: this.state.constrainToHeight || constrainToHeight,
        draggable: 'false',
        onLoad: this.onImgLoad,
        onClick: onClick,
        "aria-hidden": ariaHidden
      });
      var _renderSources = function _renderSources() {
        //https://scottjehl.github.io/picturefill/examples/demo-02.html
        return /*#__PURE__*/React.createElement(React.Fragment, null, sources && sources.length ? sources.map(renderSourceElement) : '');
      };
      var wrapImage = function wrapImage(children) {
        if (!hasAspectRatio) return children;
        return /*#__PURE__*/React.createElement(ImageWrapper, {
          "aria-label": ariaLabel,
          ratio: imageRatio
        }, children);
      };

      // Reason for separate renders:
      // If one viewport contains sources and one does not, and you scale the component, the DOM will break.
      // Cannot remove children of HTML primitive picture element, need to replace the picture element entirely
      var _returnWithSources = function _returnWithSources() {
        return wrapImage( /*#__PURE__*/React.createElement(Picture, {
          constrainToHeight: constrainToHeight,
          constrainToWidth: constrainToWidth,
          positionX: positionX,
          key: "sources"
        }, _renderSources(), ImageComponent));
      };
      var _returnWithout = function _returnWithout() {
        return wrapImage( /*#__PURE__*/React.createElement(Picture, {
          constrainToHeight: constrainToHeight,
          constrainToWidth: constrainToWidth,
          positionX: positionX,
          key: "no-sources"
        }, ImageComponent));
      };
      return sources && sources.length ? _returnWithSources() : _returnWithout();
    }
  }]);
  return Image;
}(React.Component);
Image.propTypes = propTypes;
Image.defaultProps = defaultProps;
export default withVDSManager(Image);